<ol class="timeline">
  @for (step of ordered(); track $index; let i = $index) {
    <li class="timeline__item" [attr.data-status]="step.status">
      <span class="timeline__dot" aria-hidden="true"></span>
      <div class="timeline__content">
        <button
          type="button"
          class="timeline__row"
          (click)="toggle(i)"
          [disabled]="!hasDetails(step)"
          [attr.aria-expanded]="expanded().has(i)">
          <span class="timeline__title">{{ step.step_order }} · {{ step.step_name }}</span>
          <ai-status-badge [status]="step.status" />
          @if ((step.attempt ?? 1) > 1) {
            <ai-status-badge [label]="'tentativa ' + step.attempt" variant="waiting" />
          }
          @if ((step.iteration ?? 1) > 1) {
            <ai-status-badge [label]="'rodada ' + step.iteration" variant="open" />
          }
          <span class="timeline__meta">
            {{ step.agent_name || '—' }}
            @if (step.model) {
              · <span class="ai-mono">{{ step.model }}</span>
            }
            · {{ duration(step) }} ·
            {{ tokens(step.usage) === null ? '—' : (tokens(step.usage) | number) }} tokens
          </span>
          @if (hasDetails(step)) {
            <i
              class="pi"
              [class.pi-chevron-down]="!expanded().has(i)"
              [class.pi-chevron-up]="expanded().has(i)"
              aria-hidden="true"></i>
          }
        </button>
        @if (step.returned_to_step_order) {
          <p class="timeline__return">
            ↩ Devolveu para a etapa {{ step.returned_to_step_order }}: {{ step.return_reason }}
          </p>
        }
        @if (expanded().has(i)) {
          <div class="timeline__details">
            @if (step.error) {
              <pre class="timeline__error">{{ step.error }}</pre>
            }
            @if (step.output) {
              <markdown class="timeline__output" [data]="step.output"></markdown>
            }
          </div>
        }
      </div>
    </li>
  } @empty {
    <li class="timeline__empty">Nenhuma etapa executada.</li>
  }
</ol>
